import { render, staticRenderFns } from "./Custom_select.vue?vue&type=template&id=5f0b271f&scoped=true&"
import script from "./Custom_select.vue?vue&type=script&lang=ts&"
export * from "./Custom_select.vue?vue&type=script&lang=ts&"
import style0 from "./Custom_select.vue?vue&type=style&index=0&id=5f0b271f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0b271f",
  null
  
)

export default component.exports